export const getIsPosting = state => state.getIn(['report', 'isPosting']);
export const getErrMsg = state => state.getIn(['report', 'errMsg']);

export const getReportName = state => state.getIn(['report', 'reportName']);
export const getRowList = state => state.getIn(['report', 'rowList']);
